import { useLayoutEffect, useRef } from "react";

export const scrollDashboardToTop = () => {
  const container = document.querySelector<HTMLElement>("[data-dashboard-scroll]");
  (container || window).scrollTo({ top: 0, left: 0, behavior: "auto" });
};

export const useScrollOnTabChange = (activeTab: string) => {
  const previousTab = useRef(activeTab);
  useLayoutEffect(() => {
    if (previousTab.current !== activeTab) scrollDashboardToTop();
    previousTab.current = activeTab;
  }, [activeTab]);
};
